function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Drawer, Hidden, IconButton, List } from '@material-ui/core';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import MenuItem from "../MenuItem/index.js";
import { useStyles } from "./styles.js";
export const MenuMobile = ({
  open,
  toggleMenu,
  menu
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Hidden, {
    only: ['md', 'lg', 'xl'],
    implementation: "css"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement(MenuRoundedIcon, {
    color: "secondary"
  })), /*#__PURE__*/React.createElement(Drawer, {
    anchor: "left",
    open: open,
    variant: "temporary",
    onClose: toggleMenu
  }, /*#__PURE__*/React.createElement(List, {
    className: classes.list
  }, menu.map((props, idx) => /*#__PURE__*/React.createElement(MenuItem, _extends({
    key: `menu_${idx}`
  }, props, {
    onClose: toggleMenu,
    mobile: true
  }))))));
};
MenuMobile.displayName = 'MenuMobile';
export default MenuMobile;